import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Refreshes GPS Data
 *
 * @private
 */
export const pauseGpsPoll = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  void,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/gps/refreshData', async (_params, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/gps/pausePoll', {
      category: 'rpc',
      type: 'rpc/gps/pausePoll',
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(`Unknown error on {pauseGpsPoll}`, { tags: ['rpc'] }, 'error')

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Pause GPS poll Failed`,
      error,
    })
  }
})
